import { Component, Inject } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {
  NotificacionControllerService
} from 'api-rest';
import { SnackbarService } from '../../../../services/snackbar.service';
import { map } from 'rxjs';
import Swal from 'sweetalert2';
import { SpinnerService } from '../../../../services/spinner.service';
import { NotificationDialogComponent } from '../notification-dialog/notification-dialog.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'lib-notification-search',
  templateUrl: './notification-search.component.html',
  styleUrls: ['./notification-search.component.scss'],
})
export class NotificationSearchComponent {
  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;

  defaultFilter: boolean = true;
  headArray: any = [
    {
      Head: 'Fecha desde',
      FieldName: 'fechaDesde',
      renderValue: (item: any) => this.datePipe.transform(item.fechaDesde, 'dd/MM/yyyy'),
      OrderValue: (item: any) => {
        if (item.fechaDesde) {
          return new Date(item.fechaDesde);
        }
        return null;
      },
    },
    {
      Head: 'Fecha hasta',
      FieldName: 'fechaHasta',
      renderValue: (item: any) => this.datePipe.transform(item.fechaHasta, 'dd/MM/yyyy'),
      OrderValue: (item: any) => {
        if (item.fechaHasta) {
          return new Date(item.fechaHasta);
        }
        return null;
      },

    },
    {
      Head: 'Mensaje',
      FieldName: 'mensaje',
      Tooltip: true,
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        { nameButton: 'edit', icon: 'open_in_new', toolTip: 'Editar' },
        { nameButton: 'delete', icon: 'delete', toolTip: 'Borrar' },
      ],
      width: '8',
      permanent: true,
    },
  ];
  gridArray: any[] = [];

  searchForm: FormGroup;
  flagSearch: boolean = false;
  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;

  constructor(
    @Inject('environment') private environment: any,
    private notificacionService: NotificacionControllerService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private snackbarService: SnackbarService,
    public spinnerSrv: SpinnerService,
    private datePipe: DatePipe
  ) {
    this.searchForm = this.formBuilder.group({});
  }

  ngOnInit(): void {
    this.searchData();
    
  }

  renderPage(event: number) {
    this.pageNumber = event;
    this.obtenerNotificaciones();
  }


  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.searchData();
  }

  checked(item: any) {}

  searchData() {
    this.pageNumber = 1;
    this.obtenerNotificaciones();
  }

  obtenerNotificaciones() {
    if (this.searchForm.invalid) {
      this.searchForm.markAllAsTouched();
      return;
    }
    this.spinnerSrv.loadingShow();
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    this.notificacionService
      .findAll2({
        page: page,
        size: this.pageSize,
      })
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.spinnerSrv.loadingHide();
            this.flagSearch = data.content?.length != 0 ? true : false;
            this.gridArray = data.content;
            this.recordsTotal = data.totalElements ?? 0;
            //this.totalSearch = this.gridArray.length;
          }
        },
        error: (error) => {
          this.spinnerSrv.loadingHide();
          this.snackbarService.showSnackBar(
            'Error obteniendo listado de notificaciones',
            'error'
          );
        },
      });
  }

  action(item: any) {
    if (item.nameButton == 'edit') {
      this.openModalDetail(item, true);
    } else if (item.nameButton == 'delete') {
      this.confirmacion(
        `¿Desea eliminar la notificación seleccionada?`,
        () => this.eliminarNotificacion(item)
      );
    }
  }

  clearSearcher() {
    this.searchForm.reset();
    this.flagSearch = false;
    this.gridArray = [];
  }

  getFormControl(controlName: string): FormControl {
    return this.searchForm.controls[controlName] as FormControl;
  }

  eliminarNotificacion(item: any) {
    this.spinnerSrv.loadingShow();
    this.notificacionService
      .eliminarNotificacion(item.id)
      .subscribe({
        next: (data: any) => {
          this.spinnerSrv.loadingHide();
          this.snackbarService.showSnackBar(
            'Se ha eliminado la notificación correctamente.',
            'success'
          );
          this.searchData();
        },
        error: (error) => {
          this.spinnerSrv.loadingHide();
          this.snackbarService.showSnackBar(
            'Error al eliminar la notificación.',
            'error'
          );
        },
      });
  }

  confirmacion(titulo: string, callBack: Function): void {
    Swal.fire({
      text: titulo,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        callBack();
      }
    });
  }

  openModalDetail(element?: any, editMode = false): void {
      const dialogRef = this.dialog.open(NotificationDialogComponent, {
        width: '950px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          item: element,
          editMode: editMode,
        },
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.searchData();
        }
      });
  }
}
